import { render, staticRenderFns } from "./ConnectedChannelsSection.vue?vue&type=template&id=012a462c&scoped=true"
import script from "./ConnectedChannelsSection.vue?vue&type=script&lang=js"
export * from "./ConnectedChannelsSection.vue?vue&type=script&lang=js"
import style0 from "./ConnectedChannelsSection.vue?vue&type=style&index=0&id=012a462c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012a462c",
  null
  
)

export default component.exports